module.exports = __webpack_public_path__ + "static/media/dinner-table.f1a0fd30.png";